export const ALERT_SUCCESS = 'SUCCESS';
export const ALERT_ERROR = 'ERROR';
